/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const HeaderBox = styled(Box)(({theme}) => ({
  height: '60px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(0, 6),

  [`${theme.breakpoints.down('md')}`]: {
    flexDirection: 'column',
    padding: theme.spacing(4, 0, 6, 0),
    alignItems: 'flex-start',
  },
}));

export const HeaderBoxMobile = styled(Box)(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(4, 2),
}));
